import styled from "styled-components";
import sql from "./sql.png"

const Sql = styled.img`
  width: 152px;
height: 250px;

border-radius: 8px;
    `

export default () => (
    <Sql src={sql} alt={"sql"}/>
)
